export default __webpack_public_path__ + "static/media/icon_deposit_points.121e2b00.svg";